/* eslint-disable func-call-spacing */
const Index = () => import('~pages/Project/Documents/Index.vue')
const NavBar = () => import('~components/navbar/NavBar.vue')
const Documents = () => import('~pages/Project/Documents/Documents.vue')

export default [
  {
    path: '/:project/documents',
    components: {
      default: Index,
      navbar: NavBar
    },
    meta: {
      access: ['project.document.view', 'org.project.view']
    },
    children: [
      {
        name: 'documents',
        path: '/',
        component: Documents,
        meta: {
          access: ['project.document.view', 'org.project.view']
        }
      }
    ]
  }
]
